var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isShow
        ? _c(
            "el-button",
            {
              staticStyle: { "margin-left": "8px" },
              attrs: { type: "primary", size: "small" },
              on: {
                click: function($event) {
                  _vm.dialogVisible = true
                }
              }
            },
            [_vm._v("+ 新增标签组")]
          )
        : _vm._e(),
      _c(
        "el-scrollbar",
        { style: { height: _vm.isShow ? "700px" : "500px" } },
        _vm._l(_vm.groupList, function(item, i) {
          return _c("div", { staticClass: "group" }, [
            _c("div", { class: _vm.isShow ? "title" : "title1" }, [
              _vm._v(_vm._s(item.groupName) + " "),
              _c(
                "span",
                {
                  staticStyle: { color: "#fff" },
                  on: {
                    click: function($event) {
                      return _vm.delTagGroup(item.groupId)
                    }
                  }
                },
                [_vm._v("X")]
              )
            ]),
            _c(
              "div",
              [
                _vm._l(item.groupChatTagDetailDtoList, function(tag) {
                  return _c(
                    "el-tag",
                    {
                      key: item.tagId,
                      class: [{ "hasCheck-tag": tag.hasCheck }],
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        closable: _vm.isShow,
                        "disable-transitions": false,
                        type: tag.type == 1 ? "" : "info"
                      },
                      on: {
                        close: function($event) {
                          return _vm.deleteGroupTag(tag.tagId)
                        },
                        click: function($event) {
                          return _vm.handleClick(tag)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(tag.tagName) + " ")]
                  )
                }),
                _vm.isShow
                  ? _c(
                      "el-button",
                      {
                        staticClass: "button-new-tag",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.setGroupTagId(item.groupId)
                          }
                        }
                      },
                      [_vm._v("+ 新建标签")]
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        }),
        0
      ),
      !_vm.isShow
        ? _c(
            "div",
            { staticStyle: { "text-align": "right" } },
            [
              _c("el-button", { on: { click: _vm.handleBack } }, [
                _vm._v("返回")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确认")]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增标签组",
            visible: _vm.dialogVisible,
            width: "30%",
            "destroy-on-close": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleDialogClose
          }
        },
        [
          _c("el-input", {
            attrs: {
              placeholder: "请输入标签组名",
              maxlength: "20",
              "show-word-limit": ""
            },
            model: {
              value: _vm.groupItem,
              callback: function($$v) {
                _vm.groupItem = $$v
              },
              expression: "groupItem"
            }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.groupItem.length == 0
                  },
                  on: { click: _vm.createGroupTag }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增群标签",
            visible: _vm.groupTagVisible,
            width: "30%",
            "destroy-on-close": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.groupTagVisible = $event
            },
            close: _vm.handleDialogClose
          }
        },
        [
          _c("el-input", {
            attrs: {
              placeholder: "请输入标签名",
              maxlength: "20",
              "show-word-limit": ""
            },
            model: {
              value: _vm.groupTag,
              callback: function($$v) {
                _vm.groupTag = $$v
              },
              expression: "groupTag"
            }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.groupTagVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.groupTag.length == 0
                  },
                  on: { click: _vm.createTag }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }